import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Header, Sidebar } from '../Layout';
import { Link } from 'react-router-dom';
import { getPaymentHistory } from '../../../actions/adminActions'
import DataTablePayments from './DataTablePayments';

const PaymentHistory = (props) => {

    const dispatch = useDispatch()
    const { paymentHistories } = useSelector(state => state.adminStore)

    useEffect(() => {
         dispatch(getPaymentHistory())
    }, [dispatch])
   
    return (
        <>
            <Header />
            <Sidebar/>
            <div id="main-content">
                <div className="block-header">
                    <div className="row clearfix">
                        <div className="col-md-6 col-sm-12">
                            <h2>User Payment History</h2>
                        </div>            
                        <div className="col-md-6 col-sm-12 text-right">
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/"><i className="icon-home"></i></Link></li>
                                <li className="breadcrumb-item active">Payment History</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="row clearfix">
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="header">
                                    <h2>Payment History </h2>
                                </div>
                                <div className="body py-1">
                                    <div className="table text-center">
                                        <DataTablePayments data={paymentHistories} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default PaymentHistory;